<template>
  <div class="questions">
    <el-form
      :inline="true"
      :model="searchForm"
      ref="searchForm"
      class="form-inline"
      size="small"
    >
      <el-form-item label="题目名称" prop="query">
        <el-input v-model="searchForm.query" placeholder="题目名称"></el-input>
      </el-form-item>
      <el-form-item label="题型" prop="type">
        <el-select
          v-model="searchForm.type"
          placeholder="请选择"
          style="width: 140px"
        >
          <el-option
            v-for="item in typeList"
            :key="item.type"
            :label="item.label"
            :value="item.type"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="章节" prop="chapterId">
        <el-cascader
          v-model="searchForm.chapterId"
          :options="chapters"
          :props="{
            label: 'title',
            value: 'chapterId',
            emitPath: false,
          }"
          :show-all-levels="false"
          placeholder="请选择章节"
          clearable
        ></el-cascader>
        <!-- <el-select
          v-model="searchForm.chapterId"
          placeholder="请选择章节"
          clearable
        >
          <el-option label="全部" :value="null"></el-option>
          <el-option-group
            v-for="group in chapters"
            :key="group.chapterId"
            :label="group.title"
          >
            <el-option
              v-for="item in group.children"
              :key="item.chapterId"
              :label="item.title"
              :value="item.chapterId"
            >
            </el-option>
          </el-option-group>
        </el-select> -->
      </el-form-item>
      <el-form-item style="float: right; margin-right: 0">
        <el-button type="primary" icon="el-icon-search" @click="getList"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" @click="resetForm('searchForm')"
          >重置</el-button
        >
      </el-form-item>
    </el-form>
    <div class="t-row">
      <div class="info">
        <span>单选题: {{ typeNum.RADIO }}</span>
        <span>多选题: {{ typeNum.CHECKBOX }}</span>
        <span>判断题: {{ typeNum.BOOLEAN }}</span>
        <span>填空题: {{ typeNum.SUPPLY }}</span>
        <span>简答题: {{ typeNum.ANSWER }}</span>
        <span
          >合计:
          {{
            typeNum.RADIO +
            typeNum.CHECKBOX +
            typeNum.BOOLEAN +
            typeNum.SUPPLY +
            typeNum.ANSWER
          }}</span
        >
      </div>
      <div class="btns">
        <el-button
          v-show="selectedIds.length != 0"
          type="danger"
          size="small"
          @click="handleDelBatch"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="$refs.add.visible = true"
          >新增</el-button
        >
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          style="margin-right: 10px"
          @click="handleDown"
          >下载模板</el-button
        >
        <el-upload
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleImport"
          style="display: inline-block"
        >
          <el-button type="primary" size="small" icon="el-icon-upload2"
            >导入</el-button
          >
        </el-upload>
      </div>
    </div>
    <el-table
      :data="list"
      stripe
      style="width: 100%"
      class="question_list"
      ref="table"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
        :selectable="(row) => !!row.userId"
      >
      </el-table-column>
      <el-table-column prop="question" label="题目名称" show-overflow-tooltip>
      </el-table-column>

      <el-table-column
        prop="type"
        label="题型"
        :formatter="typeFormatter"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        :formatter="formatter"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="goDetail(scope.row.questionId, 0)"
          >
            查看
          </el-button>
          <el-button
            v-show="scope.row.userId"
            type="text"
            size="small"
            @click="goDetail(scope.row.questionId, 1)"
          >
            修改
          </el-button>
          <el-button
            v-show="scope.row.userId"
            type="text"
            size="small"
            @click="handleDel(scope.row.questionId)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="foot_page">
      <el-pagination
        background
        layout="prev, pager, next, jumper"
        :page-size="searchForm.limit"
        :current-page.sync="searchForm.page"
        :total="total"
        @current-change="getList"
      ></el-pagination>
    </div>
    <addQuestion ref="add" :chapterList="chapters" @update="getList" />
  </div>
</template>

<script>
import { checkType, handleTree, formatDate } from "@/utils/index";
import {
  questionList,
  delQuestion,
  importQuestion,
  typeQuestionNum,
} from "@/api/questionBank";
import { chapterList } from "@/api/chapter";
import addQuestion from "./addQuestion";

export default {
  components: { addQuestion },
  data() {
    return {
      checkType,
      list: [],
      searchForm: {
        page: 1,
        limit: 10,
        query: "",
        courseId: null,
        chapterId: null,
        type: null,
      },
      total: 0,
      typeNum: {},
      typeList: [
        { label: "全部", type: null },
        { label: "单选题", type: "RADIO" },
        { label: "多选题", type: "CHECKBOX" },
        { label: "判断题", type: "BOOLEAN" },
        { label: "填空题", type: "SUPPLY" },
        { label: "简答题", type: "ANSWER" },
      ],
      chapters: [],
      selectedIds: [],
    };
  },
  created() {
    this.getChapterList();
    this.getList();
  },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.chapters = handleTree(res.data, "chapterId");
        } else {
          console.log(res.msg);
        }
      });
    },
    // 题型题目数量
    getTypeNum() {
      typeQuestionNum({ courseId: this.$route.query.courseId }).then(
        ({ code, data, msg }) => {
          if (code == 0) {
            this.typeNum = data;
          } else {
            console.log(msg);
          }
        }
      );
    },

    // 题目列表
    getList() {
      this.getTypeNum();
      this.searchForm.courseId = this.$route.query.courseId;
      this.$loading.show();
      questionList(this.searchForm).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getList();
    },
    formatter(row) {
      return formatDate(row.createTime, "YYYY-MM-DD HH:mm");
    },
    typeFormatter(row) {
      return checkType(row.type);
    },
    goDetail(questionId, isEdit) {
      this.$router.push({
        path: "/classCourse/questionBank/detail",
        query: {
          ...this.$route.query,
          questionId,
          isEdit,
        },
      });
    },
    // 删除题目
    handleDel(questionId) {
      this.$confirm("确定要删除题目吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delQuestion(questionId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.questionId);
    },
    handleDelBatch() {
      this.handleDel(this.selectedIds);
    },
    // 下载模板
    handleDown() {
      window.open(
        `${process.env.VUE_APP_API_DOMAIN}/app/teacher/question/template`,
        "_blank"
      );
    },
    // 导入
    handleImport(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      this.$loading.show();
      importQuestion({
        courseId: this.$route.query.courseId,
        file: formData,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("导入成功！");
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.questions {
  padding: 20px 33px;
  text-align: left;
  background-color: #fff;
  ::v-deep .question_list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
  .t-row {
    margin-bottom: 20px;
    line-height: 32px;
    overflow: hidden;
    .info {
      float: left;
      span {
        margin-right: 10px;
      }
    }
    .btns {
      float: right;
      text-align: right;
    }
  }
  .foot_page {
    margin-top: 20px;
    text-align: right;
  }
}
</style>